import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Buffer } from 'buffer';
import { SERVER_API_URL } from '@app/app.constants';

@Injectable({
  providedIn: 'root',
})
export class AirCallService {
  public authorizationAirCall: any;
  public apiURL = SERVER_API_URL;

  constructor(public http: HttpClient) {
    // const auth = Buffer.from(
    //   `${environment.AIRCALL_KEYS.API_ID}:${environment.AIRCALL_KEYS.API_TOKEN}`
    // ).toString('base64');
    // this.authorizationAirCall = {
    //   headers: new HttpHeaders({
    //     Authorization: 'Basic ' + auth,
    //   }),
    // };
  }

  getAvailableAgents() {
    return this.http.get<any>(
      this.apiURL + 'aircall/users/availabilities',
      this.authorizationAirCall
    );
  }

  listNumbers() {
    return this.http.get<any>(
      this.apiURL + 'aircall/numbers',
      this.authorizationAirCall
    );
  }

  startOutboundCall(agentId: string, phoneNumber: string, numbersId: number) {
    return this.http.post<any>(
      this.apiURL + 'aircall/users/' + agentId + '/calls',
      {
        to: phoneNumber,
        number_id: numbersId,
      },
      this.authorizationAirCall
    );
  }
}
